---
title: "Dynamic Test Model Built"
date: 2026-02-06
category: "Engineering"
---

The Dynamic Test Model is fully built up! This build brings together every major structural element of the telescope: the optical bench, the metering struts, the mirror surrogates, and a working fast steering mirror stage. Each interface was checked against the flight design during integration, with no surprises.

![Dynamic Test Model fully assembled, ready for shipping to vibration test](/images/blog-dynamic-test-model/msm-build-1.jpg)

## What's Next

Next stop: the shaker table. In a few weeks we will load up the truck and head to vibration testing to validate the structure against launch loads.
